// extracted by mini-css-extract-plugin
export default {"news":"News_news__IhGgz","news__wrapperUp":"News_news__wrapperUp__AXgSy","news__wrapper":"News_news__wrapper__OIPPN","pseduo__track":"News_pseduo__track__57k+K"};